import { api as defaultApi } from "api/base";
import type { Campaign } from "./Campaign.types";

export const CAMPAIGN_ENDPOINT = `v1/campaigns`;

/**
 * @summary - Fetches all campaigns available to the given user
 */
export const getCampaigns = async (
    userId: string,
    api = defaultApi
): Promise<Campaign[]> => {
    const { data } = await api.get(CAMPAIGN_ENDPOINT, {
        params: { userId }
    });
    return data;
};

/**
 * @summary - Creates a new campaign and returns the campaign object
 */
export const createNewCampaign = async (
    requestData: Partial<Campaign>,
    api = defaultApi
): Promise<{ data: Campaign }> => {
    const {
        data: { data }
    } = await api.postJSON(CAMPAIGN_ENDPOINT, requestData);
    return data;
};

/**
 * @summary - Updates the source of a specified campaign
 */
export const updateCampaign = async (
    id: string,
    requestData: Partial<Campaign>,
    api = defaultApi
): Promise<Campaign> => {
    const { data } = await api.putJSON(
        `${CAMPAIGN_ENDPOINT}/${id}`,
        requestData
    );
    return data;
};

export const deleteCampaign = async (id, api = defaultApi) => {
    await api.remove(`${CAMPAIGN_ENDPOINT}/${id}`);
};
